import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50dcb9d1&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=50dcb9d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dcb9d1",
  null
  
)

export default component.exports